import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  content: {
    '& > div + div': {
      marginTop: theme.spacing(3),
    },
  },
  buttonWrapper: {
    padding: '16px 0',
  },
  themeRow: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
  },
  labelWithTooltip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: 0,
  },
  restRow: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    minWidth: 0,
    gap: theme.spacing(1),

    '& > div:first-of-type': {
      flex: 1,
      minWidth: 0,
    },
  },
  restInput: {
    flex: 1,
    minWidth: 0,
  },
  resetButton: {
    flexShrink: 0,
  },
}));
